(function() {
  class $6b5ae21dc8573706$var$AnnouncementBanner extends HTMLElement {
    constructor() {
      super();
      this._activeScheme = null;
    }
    connectedCallback() {
      this._defaultScheme = (this.dataset.defaultScheme || "").trim();
      this._headerScheme = (this.dataset.headerScheme || "").trim();
      if (!this._headerScheme) return;
      this._applyScheme(this._defaultScheme);
      this._onDesktopNavToggle = e => {
        this._desktopNavOpen = e.detail.open;
        this._updateScheme();
      };
      this._onMobileNavToggle = e => {
        this._mobileNavOpen = e.detail.open;
        this._updateScheme();
      };
      window.addEventListener("desktop-nav:toggle", this._onDesktopNavToggle);
      window.addEventListener("mobile-nav:toggle", this._onMobileNavToggle);
    }
    disconnectedCallback() {
      window.removeEventListener("desktop-nav:toggle", this._onDesktopNavToggle);
      window.removeEventListener("mobile-nav:toggle", this._onMobileNavToggle);
    }
    _applyScheme(scheme) {
      if (this._activeScheme === scheme) return;
      if (this._activeScheme) {
        for (const cls of this._activeScheme.split(/\s+/)) if (cls) this.classList.remove(cls);
      }
      for (const cls of scheme.split(/\s+/)) if (cls) this.classList.add(cls);
      this._activeScheme = scheme;
    }
    _updateScheme() {
      const navOpen = this._desktopNavOpen || this._mobileNavOpen;
      this._applyScheme(navOpen ? this._headerScheme : this._defaultScheme);
    }
  }
  if (!customElements.get("announcement-banner")) customElements.define("announcement-banner", $6b5ae21dc8573706$var$AnnouncementBanner);
})();